var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3000",
    d: "M18.675 8.7a1.72 1.72 0 0 0-1.21-1.214C16.4 7.2 12.12 7.2 12.12 7.2s-4.276 0-5.345.286a1.72 1.72 0 0 0-1.21 1.213C5.28 9.77 5.28 12 5.28 12s0 2.232.285 3.301c.157.59.62 1.054 1.21 1.213 1.069.286 5.345.286 5.345.286s4.279 0 5.345-.286a1.72 1.72 0 0 0 1.21-1.213c.285-1.069.285-3.3.285-3.3s0-2.233-.285-3.302Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.754 14.058 14.307 12l-3.553-2.057z"
  })));
};
export default SvgYoutube;